import { Routes } from '@models/route';
import { lazy } from 'react';

const ProductsListing = lazy(() =>
  import('@pages/products/ProductsListing').then((p) => ({
    default: p.ProductsListing,
  }))
);
const ProductDetails = lazy(() =>
  import('@pages/products/ProductDetailsPage').then((p) => ({
    default: p.ProductDetailsPage,
  }))
);

export const ProductRoutes: Routes = [
  {
    path: 'admin/products',
    component: ProductsListing,
    children: [
      {
        path: 'create',
        component: ProductDetails,
      },
      {
        path: ':id',
        component: ProductDetails,
      },
    ],
  },
];
